import { useController } from 'rest-hooks';
import { PolicyRule } from './interfaces/policyRule';
import { ScoreModel } from './interfaces/scoreModel';
import {
  scoreModel2PolicyRuleFactory,
  ScoreModel2PolicyRuleResource
} from './resources/scoreModel2PolicyRulesResource';

export const useScoreModel2PolicyRule = () => {
  const { fetch } = useController();
  return {
    createScoreModel2PolicyRules: (scoreModel: ScoreModel, policyRules: PolicyRule[]) =>
      Promise.all(
        policyRules.map((item) => {
          const scoreModel2PolicyRule = scoreModel2PolicyRuleFactory(scoreModel, item);
          return fetch(ScoreModel2PolicyRuleResource.create(), scoreModel2PolicyRule);
        })
      ),
    deleteScoreModel2PolicyRules: (scoreModel: ScoreModel, policyRules: PolicyRule[]) =>
      Promise.all(
        policyRules.map((item) =>
          fetch(ScoreModel2PolicyRuleResource.delete(), {
            scoreModelId: scoreModel.scoreModelId,
            policyRuleId: item.policyRuleId
          })
        )
      )
  };
};
